import { defaultTicketFilter } from '../ticket-filters.i';
import { SavedFilterType } from './saved-filter-type.enum';
var SavedFilterBuilder = /** @class */ (function () {
    function SavedFilterBuilder() {
        this.savedFilter = {
            id: 'bobi',
            name: 'bobson',
            creationDate: Date.now(),
            lastUpdateDate: Date.now(),
            ownerId: 'bob',
            type: SavedFilterType.PUBLIC,
            filters: defaultTicketFilter
        };
    }
    SavedFilterBuilder.prototype.withId = function (id) {
        this.savedFilter.id = id;
        return this;
    };
    SavedFilterBuilder.prototype.withOwnerId = function (ownerId) {
        this.savedFilter.ownerId = ownerId;
        return this;
    };
    SavedFilterBuilder.prototype.withName = function (name) {
        this.savedFilter.name = name;
        return this;
    };
    SavedFilterBuilder.prototype.withType = function (type) {
        this.savedFilter.type = type;
        return this;
    };
    SavedFilterBuilder.prototype.withCreationDate = function (creationDate) {
        this.savedFilter.creationDate = creationDate;
        return this;
    };
    SavedFilterBuilder.prototype.withLastUpdateDate = function (lastUpdateDate) {
        this.savedFilter.lastUpdateDate = lastUpdateDate;
        return this;
    };
    SavedFilterBuilder.prototype.withFilter = function (filters) {
        this.savedFilter.filters = filters;
        return this;
    };
    SavedFilterBuilder.prototype.withOneInboxDisplayedColumns = function (oneInboxDisplayedColumns) {
        this.savedFilter.oneInboxDisplayedColumns = oneInboxDisplayedColumns;
        return this;
    };
    SavedFilterBuilder.prototype.withBrandFilters = function (brandFilters) {
        this.savedFilter.brandFilters = brandFilters;
        return this;
    };
    SavedFilterBuilder.prototype.withLocale = function (locale) {
        this.savedFilter.locale = locale;
        return this;
    };
    SavedFilterBuilder.prototype.build = function () {
        return this.savedFilter;
    };
    return SavedFilterBuilder;
}());
export { SavedFilterBuilder };
//# sourceMappingURL=saved-filter.builder.js.map